import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { IconButtonComponent } from 'src/app/common/icon-button/icon-button.component';

/**
 * UserMenuComponent displays a user menu with options for switching users and logging out.
 *
 * @example
 * <crownx-user-menu [IsSwitchVisible]="true" (SwitchClick)="onSwitch()" (LogoutClick)="onLogout()"></crownx-user-menu>
 *
 * @input IsSwitchVisible - Controls the visibility of the switch user option.
 * @output SwitchClick - Emits when the switch user option is clicked.
 * @output LogoutClick - Emits when the logout option is clicked.
 */
@Component({
	selector: 'crownx-user-menu',
	standalone: true,
	imports: [
		NgIf,
		MatMenuModule,
		MatIconModule,
		IconButtonComponent
	],
	templateUrl: './user-menu.component.html'
})
export class UserMenuComponent {
	/** Indicates whether the switch user option is visible. */
	@Input() IsSwitchVisible: boolean = false;

	/** Event emitted when the switch user option is clicked. */
	@Output() SwitchClick = new EventEmitter<void>();

	/** Event emitted when the logout option is clicked. */
	@Output() LogoutClick = new EventEmitter<void>();

	/** Handles the logout option click event. */
	public OnLogoutClick(): void {
		this.LogoutClick.emit();
	}

	/** Handles the switch user option click event. */
	public OnSwitchClick(): void {
		this.SwitchClick.emit();
	}
}